export default "__VITE_ASSET__DK7Im_n1__"